import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Card, CardBody, Button, Badge, Modal, ModalHeader, ModalBody, ModalFooter, Table, Spinner, Nav, NavItem, NavLink, TabContent, TabPane, Row, Col } from "reactstrap";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { Save, ArrowLeft, User, Truck, Shield, DollarSign, MapPin, Phone, Mail, Camera, FileText, CheckCircle, AlertCircle, Eye, RefreshCw, Clock } from "react-feather";
import axios from "axios";
import toastr from "toastr";
import "toastr/build/toastr.css";

const api = axios.create({ baseURL: API_WEB_URLS.BASE });

const AddEdit_MemberMaster = () => {
  const API_URL_SAVE = "MemberMaster/0/token";
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/MemberMaster/Id";
  const API_URL_CITY = `${API_WEB_URLS.MASTER}/0/token/CityMaster/Id/0`;
  const API_URL_STATE = `${API_WEB_URLS.MASTER}/0/token/StateMaster/Id/0`;
  const API_URL_USER_TYPE = `${API_WEB_URLS.MASTER}/0/token/UserTypeMaster/Id/0`;
  const API_URL_VEHICLE_TYPE = `${API_WEB_URLS.MASTER}/0/token/VehicleType/Id/0`;
  const API_URL_MEMBER_CATEGORY = `${API_WEB_URLS.MASTER}/0/token/MemberCategory/Id/0`;

  const [activeTab, setActiveTab] = useState("personal");

  const [state, setState] = useState({
    id: 0,
    formData: {
      F_UserTypeMaster: "2", // Default to Driver
      F_MemberCategory: "2",
      Name: "",
      FatherName: "",
      MotherName: "",
      MobileNo: "",
      AlternateMobileNo: "",
      Email: "",
      UserPassword: "",
      CompanyName: "",
      GSTNo: "",
      PANNo: "",
      AadharNo: "",
      DrivingLicence: "",
      Address: "",
      F_StateMaster: "",
      F_CityMaster: "",
      Pincode: "",
      F_VehicleType: "",
      VehicleNo: "",
      VehicleRegistrationNo: "",
      VehicleName: "",
      VehicleBodyType: "Open",
      WeightCapacity: "",
      AccountNo: "",
      AccountPersonName: "",
      IFSC: "",
      BankName: "",
      // Existing Photos
      UserPhoto: "",
      AadharFront: "",
      AadharBack: "",
      RCFront: "",
      RCBack: "",
      DrivingLicenseFront: "",
      DrivingLicenseBack: "",
      Insurance: "",
      PUC: "",
      PAN: "",
      DLExpiryDate: "",
      InsuranceExpiryDate: "",
      PUCExpiryDate: "",
    },
  });

  // Selected new replacement files
  const [selectedFiles, setSelectedFiles] = useState({
    UserPhoto: null,
    AadharFront: null,
    AadharBack: null,
    RCFront: null,
    RCBack: null,
    DrivingLicenseFront: null,
    DrivingLicenseBack: null,
    Insurance: null,
    PUC: null,
    PAN: null,
  });

  // Client-side local previews for newly chosen files
  const [filePreviews, setFilePreviews] = useState({});

  // Audit Logs State
  const [photoLogs, setPhotoLogs] = useState([]);
  const [loadingLogs, setLoadingLogs] = useState(false);

  // Full Image Modal State
  const [imageModal, setImageModal] = useState({ show: false, src: "", title: "" });

  const [cityList, setCityList] = useState([]);
  const [filteredCityList, setFilteredCityList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [userTypeList, setUserTypeList] = useState([]);
  const [vehicleTypeList, setVehicleTypeList] = useState([]);
  const [memberCategoryList, setMemberCategoryList] = useState([]);

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const nameRef = useRef(null);

  // ─── Fetch Member Data on Edit ──────────────────────────────────────────────
  useEffect(() => {
    const Id = (location.state && location.state.Id) || 0;
    if (Id > 0) {
      setState((prevState) => ({ ...prevState, id: Id }));
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT);
      fetchPhotoLogs(Id);
    }
  }, [dispatch, location.state]);

  // ─── Fetch Photo Logs ───────────────────────────────────────────────────────
  const fetchPhotoLogs = async (memberId) => {
    if (!memberId) return;
    setLoadingLogs(true);
    try {
      const res = await api.get(`MemberMaster/0/token/PhotoLogs/${memberId}`);
      const list = res?.data?.data || res?.data?.Data || [];
      setPhotoLogs(list);
    } catch (e) {
      console.warn("Could not fetch photo logs:", e);
    }
    setLoadingLogs(false);
  };

  // ─── Master Dropdowns ───────────────────────────────────────────────────────
  useEffect(() => {
    Fn_FillListData(dispatch, setCityList, "gridData", API_URL_CITY);
    Fn_FillListData(dispatch, setStateList, "gridData", API_URL_STATE);
    Fn_FillListData(dispatch, setUserTypeList, "gridData", API_URL_USER_TYPE);
    Fn_FillListData(dispatch, setVehicleTypeList, "gridData", API_URL_VEHICLE_TYPE);
    Fn_FillListData(dispatch, setMemberCategoryList, "gridData", API_URL_MEMBER_CATEGORY);
  }, [dispatch]);

  useEffect(() => {
    if (nameRef.current) {
      nameRef.current.focus();
    }
  }, []);

  const handleStateChange = (stateId, setFieldValue) => {
    setFieldValue("F_StateMaster", stateId);
    setFieldValue("F_CityMaster", "");
    if (stateId) {
      const filtered = cityList.filter((city) => city.F_StateMaster == stateId);
      setFilteredCityList(filtered);
    } else {
      setFilteredCityList([]);
    }
  };

  useEffect(() => {
    if (state.formData.F_StateMaster && cityList.length > 0) {
      const filtered = cityList.filter((city) => city.F_StateMaster == state.formData.F_StateMaster);
      setFilteredCityList(filtered);
    }
  }, [state.formData.F_StateMaster, cityList]);

  // ─── Handle New File Selection & Preview ────────────────────────────────────
  const handleFileChange = (docKey, e) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      setSelectedFiles((prev) => ({ ...prev, [docKey]: file }));
      const previewUrl = URL.createObjectURL(file);
      setFilePreviews((prev) => ({ ...prev, [docKey]: previewUrl }));
    }
  };

  // ─── Clean Image URL helper ─────────────────────────────────────────────────
  const getFullImageUrl = (fileName) => {
    if (!fileName) return null;
    if (fileName.startsWith("http://") || fileName.startsWith("https://")) {
      return fileName;
    }
    return `${API_WEB_URLS.IMAGEURL}${fileName}`;
  };

  // ─── Validation Schema ──────────────────────────────────────────────────────
  const validationSchema = Yup.object({
    F_UserTypeMaster: Yup.string().required("User Type is required"),
    Name: Yup.string().required("Name is required").min(2, "Must be at least 2 characters"),
    MobileNo: Yup.string()
      .required("Mobile number is required")
      .matches(/^[0-9]{10}$/, "Mobile number must be exactly 10 digits"),
    UserPassword: Yup.string().required("Password is required").min(4, "Password must be at least 4 characters"),

    F_MemberCategory: Yup.string().when("F_UserTypeMaster", {
      is: (val) => String(val) === "3",
      then: (schema) => schema.required("Customer category is required"),
      otherwise: (schema) => schema.notRequired(),
    }),

    FatherName: Yup.string().when("F_UserTypeMaster", {
      is: (val) => String(val) === "2",
      then: (schema) => schema.required("Father name is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  // ─── Form Submission with All Documents ─────────────────────────────────────
  const handleSubmit = async (values) => {
    const obj = JSON.parse(localStorage.getItem("user"));
    const formData = new FormData();

    // Basic & Auth Details
    formData.append("F_UserTypeMaster", values.F_UserTypeMaster || "2");
    formData.append("Name", values.Name || "");
    formData.append("FatherName", values.FatherName || "");
    formData.append("MotherName", values.MotherName || "");
    formData.append("MobileNo", values.MobileNo || "");
    formData.append("AlternateMobileNo", values.AlternateMobileNo || "");
    formData.append("Email", values.Email || "");
    formData.append("UserPassword", values.UserPassword || "");
    formData.append("UserName", values.MobileNo || "");

    // Address Details
    formData.append("Address", values.Address || "");
    formData.append("F_StateMaster", values.F_StateMaster || "");
    formData.append("F_CityMaster", values.F_CityMaster || "");
    formData.append("Pincode", values.Pincode || "");

    // Customer Specific
    if (String(values.F_UserTypeMaster) === "3") {
      formData.append("F_MemberCategory", values.F_MemberCategory || "2");
      if (String(values.F_MemberCategory) === "1") {
        formData.append("CompanyName", values.CompanyName || "");
        formData.append("GSTNo", values.GSTNo || "");
        formData.append("PANNo", values.PANNo || "");
      }
    }

    // Driver Specific
    if (String(values.F_UserTypeMaster) === "2") {
      formData.append("PANNo", values.PANNo || "");
      formData.append("AadharNo", values.AadharNo || "");
      formData.append("DrivingLicence", values.DrivingLicence || "");

      // Vehicle
      formData.append("F_VehicleType", values.F_VehicleType || "");
      formData.append("VehicleNo", values.VehicleNo || "");
      formData.append("VehicleRegistrationNo", values.VehicleRegistrationNo || "");
      formData.append("VehicleBodyType", values.VehicleBodyType || "Open");
      formData.append("VehicleName", values.VehicleName || "");
      formData.append("WeightCapacity", values.WeightCapacity || "");

      // Bank Details
      formData.append("AccountNo", values.AccountNo || "");
      formData.append("AccountPersonName", values.AccountPersonName || "");
      formData.append("IFSC", values.IFSC || "");
      formData.append("BankName", values.BankName || "");

    // Expiry Dates
      if (values.DLExpiryDate) formData.append("DLExpiryDate", values.DLExpiryDate);
      if (values.InsuranceExpiryDate) formData.append("InsuranceExpiryDate", values.InsuranceExpiryDate);
      if (values.PUCExpiryDate) formData.append("PUCExpiryDate", values.PUCExpiryDate);
    }

    // Append Id if editing
    if (state.id > 0) {
      formData.append("Id", state.id);
    }

    // Append newly selected files
    if (selectedFiles.UserPhoto) formData.append("UserPhoto", selectedFiles.UserPhoto);
    if (selectedFiles.AadharFront) formData.append("AadharFront", selectedFiles.AadharFront);
    if (selectedFiles.AadharBack) formData.append("AadharBack", selectedFiles.AadharBack);
    if (selectedFiles.RCFront) formData.append("RCFront", selectedFiles.RCFront);
    if (selectedFiles.RCBack) formData.append("RCBack", selectedFiles.RCBack);
    if (selectedFiles.DrivingLicenseFront) formData.append("DrivingLicenseFront", selectedFiles.DrivingLicenseFront);
    if (selectedFiles.DrivingLicenseBack) formData.append("DrivingLicenseBack", selectedFiles.DrivingLicenseBack);
    if (selectedFiles.Insurance) formData.append("Insurance", selectedFiles.Insurance);
    if (selectedFiles.PUC) formData.append("PUC", selectedFiles.PUC);
    if (selectedFiles.PAN) formData.append("PAN", selectedFiles.PAN);

    const uid = obj && obj.uid ? obj.uid : 0;
    formData.append("UserId", uid);

    try {
      const url = state.id > 0
        ? `${API_WEB_URLS.BASE}MemberMaster/${uid}/token/${state.id}`
        : `${API_WEB_URLS.BASE}MemberMaster/${uid}/token`;

      const res = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data && (res.data.success || res.data.Success)) {
        toastr.success(state.id > 0 ? "Member updated successfully!" : "Member created successfully!");
        navigate("/MemberMaster");
      } else {
        toastr.error(res.data?.message || res.data?.Message || "Failed to save member details.");
      }
    } catch (err) {
      console.error("Save error:", err);
      toastr.error(err.response?.data?.message || err.message || "An error occurred while saving.");
    }
  };

  // ─── Render Document Card Helper ───────────────────────────────────────────
  const renderDocumentCard = (docKey, label, icon, existingFileName) => {
    const isNewSelected = Boolean(selectedFiles[docKey]);
    const previewSrc = filePreviews[docKey] || getFullImageUrl(existingFileName);
    const hasPhoto = Boolean(previewSrc);

    return (
      <Col md={6} lg={4} className="mb-3">
        <Card className={`h-100 border ${isNewSelected ? "border-warning shadow-sm" : hasPhoto ? "border-success shadow-sm" : "border-light"}`} style={{ borderRadius: 8 }}>
          <CardBody className="p-3 d-flex flex-column justify-content-between">
            <div>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="fw-bold text-dark small d-flex align-items-center">
                  <i className={`bx ${icon} me-1 text-primary fs-5`}></i>
                  {label}
                </span>
                {isNewSelected ? (
                  <Badge color="warning" className="text-dark small">
                    <RefreshCw size={11} className="me-1" /> New Selected
                  </Badge>
                ) : hasPhoto ? (
                  <Badge color="success" className="small">
                    <CheckCircle size={11} className="me-1" /> Uploaded
                  </Badge>
                ) : (
                  <Badge color="secondary" className="small">
                    <AlertCircle size={11} className="me-1" /> Not Uploaded
                  </Badge>
                )}
              </div>

              {/* Photo Preview Box */}
              <div
                className="position-relative bg-light rounded d-flex align-items-center justify-content-center mb-2 overflow-hidden border"
                style={{ height: 160, cursor: hasPhoto ? "pointer" : "default" }}
                onClick={() => hasPhoto && setImageModal({ show: true, src: previewSrc, title: label })}
              >
                {hasPhoto ? (
                  <>
                    <img
                      src={previewSrc}
                      alt={label}
                      style={{ width: "100%", height: "100%", objectFit: "contain" }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "https://via.placeholder.com/300x160?text=Image+Not+Found";
                      }}
                    />
                    <div
                      className="position-absolute bottom-0 end-0 m-1 bg-dark bg-opacity-75 text-white p-1 rounded small px-2"
                      style={{ fontSize: "0.75rem" }}
                    >
                      <Eye size={12} className="me-1" /> View Full
                    </div>
                  </>
                ) : (
                  <div className="text-center text-muted p-2">
                    <Camera size={32} className="opacity-50 mb-1" />
                    <div style={{ fontSize: "0.75rem" }}>No photo uploaded</div>
                  </div>
                )}
              </div>

              {/* Existing file name text if available */}
              {existingFileName && !isNewSelected && (
                <div className="text-truncate text-muted small mb-2" style={{ fontSize: "0.7rem" }} title={existingFileName}>
                  <strong>File:</strong> {existingFileName}
                </div>
              )}
              {isNewSelected && (
                <div className="text-truncate text-warning fw-semibold small mb-2" style={{ fontSize: "0.7rem" }}>
                  <strong>New:</strong> {selectedFiles[docKey].name}
                </div>
              )}
            </div>

            {/* Upload / Replace Action Button */}
            <div>
              <label className="btn btn-outline-primary btn-sm w-100 mb-0 d-flex align-items-center justify-content-center cursor-pointer">
                <Camera size={13} className="me-1" />
                {hasPhoto ? "Replace Photo" : "Upload Photo"}
                <input
                  type="file"
                  accept="image/*,.pdf"
                  hidden
                  onChange={(e) => handleFileChange(docKey, e)}
                />
              </label>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  };

  return (
    <div style={{ padding: "12px 16px", maxWidth: 1100, margin: "0 auto" }}>
      <Card className="border shadow-sm rounded-3 mb-4">
        <CardBody className="p-3 p-md-4">
          {/* ─── Header ────────────────────────────────────────────────────────── */}
          <div className="d-flex flex-wrap align-items-center justify-content-between pb-3 mb-3 border-bottom gap-2">
            <div className="d-flex align-items-center gap-2">
              <Button
                color="light"
                size="sm"
                className="border p-2 d-flex align-items-center"
                onClick={() => navigate("/MemberMaster")}
              >
                <ArrowLeft size={16} />
              </Button>
              <div>
                <h5 className="mb-0 fw-bold text-dark d-flex align-items-center">
                  <User size={20} className="me-2 text-primary" />
                  {state.id > 0 ? `Edit Member #${state.id}` : "Add New Member"}
                </h5>
                <span className="text-muted small">
                  Complete member profile, vehicle information, photo document management & audit history.
                </span>
              </div>
            </div>

            {state.id > 0 && (
              <div className="d-flex gap-2">
                <Badge color={state.formData.IsActive ? "success" : "danger"} className="p-2 fs-6">
                  {state.formData.IsActive ? "Active Member" : "Inactive"}
                </Badge>
                {state.formData.IsApproved === 1 && (
                  <Badge color="primary" className="p-2 fs-6">
                    Approved
                  </Badge>
                )}
              </div>
            )}
          </div>

          {/* ─── Nav Tabs ──────────────────────────────────────────────────────── */}
          <Nav tabs className="mb-4">
            <NavItem>
              <NavLink
                className={`cursor-pointer fw-semibold ${activeTab === "personal" ? "active text-primary border-primary border-bottom-0" : "text-muted"}`}
                onClick={() => setActiveTab("personal")}
              >
                <User size={15} className="me-1" /> Personal & Account
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`cursor-pointer fw-semibold ${activeTab === "address" ? "active text-primary border-primary border-bottom-0" : "text-muted"}`}
                onClick={() => setActiveTab("address")}
              >
                <MapPin size={15} className="me-1" /> Address & Location
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`cursor-pointer fw-semibold ${activeTab === "vehicle" ? "active text-primary border-primary border-bottom-0" : "text-muted"}`}
                onClick={() => setActiveTab("vehicle")}
              >
                <Truck size={15} className="me-1" /> Vehicle & Bank
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={`cursor-pointer fw-semibold ${activeTab === "documents" ? "active text-primary border-primary border-bottom-0" : "text-muted"}`}
                onClick={() => setActiveTab("documents")}
              >
                <Camera size={15} className="me-1" /> Photos & Documents
              </NavLink>
            </NavItem>
            {state.id > 0 && (
              <NavItem>
                <NavLink
                  className={`cursor-pointer fw-semibold ${activeTab === "auditlogs" ? "active text-primary border-primary border-bottom-0" : "text-muted"}`}
                  onClick={() => setActiveTab("auditlogs")}
                >
                  <Clock size={15} className="me-1" /> Photo Audit History ({photoLogs.length})
                </NavLink>
              </NavItem>
            )}
          </Nav>

          {/* ─── Formik Form ──────────────────────────────────────────────────── */}
          <Formik
            enableReinitialize={true}
            initialValues={{
              ...state.formData,
              F_UserTypeMaster: state.formData.F_UserTypeMaster || "2",
              F_MemberCategory: state.formData.F_MemberCategory || "2",
            }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, setFieldValue, isSubmitting }) => {
              const isDriver = String(values.F_UserTypeMaster) === "2";
              const isCustomer = String(values.F_UserTypeMaster) === "3";

              return (
                <Form>
                  <TabContent activeTab={activeTab}>
                    {/* ─── Tab 1: Personal & Account Details ───────────────────────── */}
                    <TabPane tabId="personal">
                      <Row className="g-3">
                        <Col md={4}>
                          <label className="form-label small fw-semibold text-secondary">
                            User Type <span className="text-danger">*</span>
                          </label>
                          <Field as="select" name="F_UserTypeMaster" className="form-select form-select-sm fw-bold">
                            <option value="">-- Select User Type --</option>
                            {userTypeList.map((u) => (
                              <option key={u.Id} value={u.Id}>
                                {u.Name}
                              </option>
                            ))}
                          </Field>
                        </Col>

                        <Col md={4}>
                          <label className="form-label small fw-semibold text-secondary">
                            Full Name <span className="text-danger">*</span>
                          </label>
                          <Field
                            name="Name"
                            innerRef={nameRef}
                            className={`form-control form-control-sm ${errors.Name && touched.Name ? "is-invalid" : ""}`}
                            placeholder="Enter full name"
                          />
                          <ErrorMessage name="Name" component="div" className="invalid-feedback" />
                        </Col>

                        <Col md={4}>
                          <label className="form-label small fw-semibold text-secondary">
                            Father Name {isDriver && <span className="text-danger">*</span>}
                          </label>
                          <Field
                            name="FatherName"
                            className={`form-control form-control-sm ${errors.FatherName && touched.FatherName ? "is-invalid" : ""}`}
                            placeholder="Father's name"
                          />
                          <ErrorMessage name="FatherName" component="div" className="invalid-feedback" />
                        </Col>

                        <Col md={4}>
                          <label className="form-label small fw-semibold text-secondary">
                            Mobile Number <span className="text-danger">*</span>
                          </label>
                          <Field
                            name="MobileNo"
                            maxLength={10}
                            className={`form-control form-control-sm ${errors.MobileNo && touched.MobileNo ? "is-invalid" : ""}`}
                            placeholder="10 digit mobile"
                          />
                          <ErrorMessage name="MobileNo" component="div" className="invalid-feedback" />
                        </Col>

                        <Col md={4}>
                          <label className="form-label small fw-semibold text-secondary">Alternate Mobile</label>
                          <Field name="AlternateMobileNo" maxLength={10} className="form-control form-control-sm" placeholder="Alternate mobile" />
                        </Col>

                        <Col md={4}>
                          <label className="form-label small fw-semibold text-secondary">Email Address</label>
                          <Field name="Email" type="email" className="form-control form-control-sm" placeholder="user@domain.com" />
                        </Col>

                        <Col md={4}>
                          <label className="form-label small fw-semibold text-secondary">
                            Login Password <span className="text-danger">*</span>
                          </label>
                          <Field name="UserPassword" type="text" className="form-control form-control-sm" placeholder="Account password" />
                          <ErrorMessage name="UserPassword" component="div" className="invalid-feedback" />
                        </Col>

                        {isCustomer && (
                          <>
                            <Col md={4}>
                              <label className="form-label small fw-semibold text-secondary">Customer Category</label>
                              <Field as="select" name="F_MemberCategory" className="form-select form-select-sm">
                                <option value="2">Personal Usage</option>
                                <option value="1">Commercial / Business</option>
                              </Field>
                            </Col>

                            {String(values.F_MemberCategory) === "1" && (
                              <>
                                <Col md={4}>
                                  <label className="form-label small fw-semibold text-secondary">Company Name</label>
                                  <Field name="CompanyName" className="form-control form-control-sm" placeholder="Business / Company name" />
                                </Col>
                                <Col md={4}>
                                  <label className="form-label small fw-semibold text-secondary">GST Number</label>
                                  <Field name="GSTNo" className="form-control form-control-sm" placeholder="GSTIN" />
                                </Col>
                              </>
                            )}
                          </>
                        )}
                      </Row>
                    </TabPane>

                    {/* ─── Tab 2: Address & Location ───────────────────────────────── */}
                    <TabPane tabId="address">
                      <Row className="g-3">
                        <Col md={4}>
                          <label className="form-label small fw-semibold text-secondary">State</label>
                          <Field
                            as="select"
                            name="F_StateMaster"
                            className="form-select form-select-sm"
                            onChange={(e) => handleStateChange(e.target.value, setFieldValue)}
                          >
                            <option value="">-- Select State --</option>
                            {stateList.map((s) => (
                              <option key={s.Id} value={s.Id}>
                                {s.Name}
                              </option>
                            ))}
                          </Field>
                        </Col>

                        <Col md={4}>
                          <label className="form-label small fw-semibold text-secondary">City</label>
                          <Field as="select" name="F_CityMaster" className="form-select form-select-sm">
                            <option value="">-- Select City --</option>
                            {filteredCityList.map((c) => (
                              <option key={c.Id} value={c.Id}>
                                {c.Name}
                              </option>
                            ))}
                          </Field>
                        </Col>

                        <Col md={4}>
                          <label className="form-label small fw-semibold text-secondary">Pincode</label>
                          <Field name="Pincode" maxLength={6} className="form-control form-control-sm" placeholder="6 digit pincode" />
                        </Col>

                        <Col md={12}>
                          <label className="form-label small fw-semibold text-secondary">Full Residential / Office Address</label>
                          <Field as="textarea" rows={3} name="Address" className="form-control form-control-sm" placeholder="House no, street, locality..." />
                        </Col>
                      </Row>
                    </TabPane>

                    {/* ─── Tab 3: Vehicle & Bank Details ──────────────────────────── */}
                    <TabPane tabId="vehicle">
                      {isDriver ? (
                        <>
                          <h6 className="fw-bold text-dark border-bottom pb-2 mb-3 d-flex align-items-center">
                            <Truck size={17} className="me-2 text-primary" /> Vehicle Details
                          </h6>
                          <Row className="g-3 mb-4">
                            <Col md={4}>
                              <label className="form-label small fw-semibold text-secondary">Vehicle Type</label>
                              <Field as="select" name="F_VehicleType" className="form-select form-select-sm">
                                <option value="">-- Select Vehicle Type --</option>
                                {vehicleTypeList.map((v) => (
                                  <option key={v.Id} value={v.Id}>
                                    {v.Name}
                                  </option>
                                ))}
                              </Field>
                            </Col>

                            <Col md={4}>
                              <label className="form-label small fw-semibold text-secondary">Vehicle Number</label>
                              <Field name="VehicleNo" className="form-control form-control-sm fw-bold text-uppercase" placeholder="e.g. RJ14 AB 1234" />
                            </Col>

                            <Col md={4}>
                              <label className="form-label small fw-semibold text-secondary">Chassis / Registration No</label>
                              <Field name="VehicleRegistrationNo" className="form-control form-control-sm text-uppercase" placeholder="RC / Chassis number" />
                            </Col>

                            <Col md={4}>
                              <label className="form-label small fw-semibold text-secondary">Vehicle Body Type</label>
                              <Field as="select" name="VehicleBodyType" className="form-select form-select-sm">
                                <option value="Open">Open</option>
                                <option value="Container">Container / Closed</option>
                                <option value="Tarpaulin">Tarpaulin</option>
                              </Field>
                            </Col>

                            <Col md={4}>
                              <label className="form-label small fw-semibold text-secondary">Weight Capacity (kg / tons)</label>
                              <Field name="WeightCapacity" className="form-control form-control-sm" placeholder="e.g. 500 kg, 1 Ton" />
                            </Col>
                          </Row>

                          <h6 className="fw-bold text-dark border-bottom pb-2 mb-3 d-flex align-items-center">
                            <DollarSign size={17} className="me-2 text-success" /> Bank Payout Account Details
                          </h6>
                          <Row className="g-3">
                            <Col md={6}>
                              <label className="form-label small fw-semibold text-secondary">Account Number</label>
                              <Field name="AccountNo" className="form-control form-control-sm fw-bold" placeholder="Bank Account Number" />
                            </Col>

                            <Col md={6}>
                              <label className="form-label small fw-semibold text-secondary">Account Holder Name</label>
                              <Field name="AccountPersonName" className="form-control form-control-sm" placeholder="Name as in bank" />
                            </Col>

                            <Col md={6}>
                              <label className="form-label small fw-semibold text-secondary">IFSC Code</label>
                              <Field name="IFSC" className="form-control form-control-sm text-uppercase" placeholder="e.g. SBIN0001234" />
                            </Col>

                            <Col md={6}>
                              <label className="form-label small fw-semibold text-secondary">Bank Name</label>
                              <Field name="BankName" className="form-control form-control-sm" placeholder="e.g. State Bank of India" />
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <div className="text-center py-4 text-muted">
                          <Truck size={36} className="opacity-50 mb-2" />
                          <div>Vehicle details are only applicable for Driver accounts.</div>
                        </div>
                      )}
                    </TabPane>

                    {/* ─── Tab 4: Photos & Documents Management ────────────────────── */}
                    <TabPane tabId="documents">
                      <div className="alert alert-info py-2 px-3 small mb-4 d-flex align-items-center">
                        <i className="bx bx-info-circle fs-5 me-2 text-info"></i>
                        <span>
                          Existing photos uploaded from Mobile App or Web are previewed live from the server. Click any image to view in full size, or click <strong>Replace Photo</strong> to upload a new version.
                        </span>
                      </div>

                      {/* Expiry Dates Header Bar for Driver */}
                      {isDriver && (
                        <Card className="bg-light border-0 mb-4 rounded-3">
                          <CardBody className="p-3">
                            <h6 className="fw-bold text-dark mb-2 small text-uppercase">Document Expiry Dates</h6>
                            <Row className="g-2">
                              <Col md={4}>
                                <label className="form-label small text-muted mb-1">Driving License Expiry</label>
                                <Field type="date" name="DLExpiryDate" className="form-control form-control-sm bg-white" />
                              </Col>
                              <Col md={4}>
                                <label className="form-label small text-muted mb-1">Insurance Expiry</label>
                                <Field type="date" name="InsuranceExpiryDate" className="form-control form-control-sm bg-white" />
                              </Col>
                              <Col md={4}>
                                <label className="form-label small text-muted mb-1">PUC Expiry</label>
                                <Field type="date" name="PUCExpiryDate" className="form-control form-control-sm bg-white" />
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      )}

                      {/* Grid of 10 Document Cards */}
                      <Row>
                        {renderDocumentCard("UserPhoto", "Profile Photo (UserPhoto)", "bx-user-circle", values.UserPhoto)}
                        {renderDocumentCard("AadharFront", "Aadhaar Card (Front)", "bx-id-card", values.AadharFront)}
                        {renderDocumentCard("AadharBack", "Aadhaar Card (Back)", "bx-id-card", values.AadharBack)}
                        {renderDocumentCard("DrivingLicenseFront", "Driving License (Front)", "bx-car", values.DrivingLicenseFront)}
                        {renderDocumentCard("DrivingLicenseBack", "Driving License (Back)", "bx-car", values.DrivingLicenseBack)}
                        {renderDocumentCard("RCFront", "RC Book / Card (Front)", "bx-certification", values.RCFront)}
                        {renderDocumentCard("RCBack", "RC Book / Card (Back)", "bx-certification", values.RCBack)}
                        {renderDocumentCard("Insurance", "Vehicle Insurance", "bx-shield-quarter", values.Insurance)}
                        {renderDocumentCard("PUC", "PUC Certificate", "bx-check-shield", values.PUC)}
                        {renderDocumentCard("PAN", "PAN Card Document", "bx-credit-card-front", values.PAN)}
                      </Row>
                    </TabPane>

                    {/* ─── Tab 5: Photo Change Audit History ───────────────────────── */}
                    {state.id > 0 && (
                      <TabPane tabId="auditlogs">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h6 className="fw-bold text-dark mb-0 d-flex align-items-center">
                            <Clock size={18} className="me-2 text-primary" />
                            Document & Photo Change Log History
                          </h6>
                          <Button color="outline-primary" size="sm" onClick={() => fetchPhotoLogs(state.id)} disabled={loadingLogs}>
                            <RefreshCw size={13} className={`me-1 ${loadingLogs ? "spin" : ""}`} /> Refresh Log
                          </Button>
                        </div>

                        <div className="table-responsive border rounded-3">
                          <Table hover className="mb-0 align-middle">
                            <thead className="table-light small text-uppercase">
                              <tr>
                                <th>#</th>
                                <th>Date & Time</th>
                                <th>Document Type</th>
                                <th>Previous Photo</th>
                                <th>New Photo</th>
                                <th>Changed By</th>
                                <th>Source</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loadingLogs ? (
                                <tr>
                                  <td colSpan={7} className="text-center py-4 text-muted">
                                    <Spinner size="sm" color="primary" className="me-2" /> Loading audit history...
                                  </td>
                                </tr>
                              ) : photoLogs.length === 0 ? (
                                <tr>
                                  <td colSpan={7} className="text-center py-4 text-muted">
                                    No document change history recorded yet for this member.
                                  </td>
                                </tr>
                              ) : (
                                photoLogs.map((log, idx) => (
                                  <tr key={log.LogId || idx}>
                                    <td className="small text-muted">{idx + 1}</td>
                                    <td className="small fw-semibold text-dark">{log.ChangedDate}</td>
                                    <td>
                                      <Badge color="info" className="small">
                                        {log.DocumentType}
                                      </Badge>
                                    </td>
                                    <td className="small text-danger" style={{ maxWidth: 200, wordBreak: "break-all" }}>
                                      {log.OldPhotoName ? (
                                        <span title={log.OldPhotoName}>• {log.OldPhotoName}</span>
                                      ) : (
                                        <span className="text-muted italic">Initial Upload</span>
                                      )}
                                    </td>
                                    <td className="small text-success fw-semibold" style={{ maxWidth: 200, wordBreak: "break-all" }}>
                                      <span title={log.NewPhotoName}>• {log.NewPhotoName}</span>
                                    </td>
                                    <td className="small text-muted">{log.ChangedByUserName || "Admin Web"}</td>
                                    <td>
                                      <Badge color="light" className="text-dark border small">
                                        {log.Source || "Admin Web"}
                                      </Badge>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </TabPane>
                    )}
                  </TabContent>

                  {/* ─── Bottom Action Bar ──────────────────────────────────────── */}
                  <div className="d-flex justify-content-between align-items-center pt-3 mt-4 border-top">
                    <Button
                      type="button"
                      color="secondary"
                      outline
                      size="sm"
                      onClick={() => navigate("/MemberMaster")}
                    >
                      <ArrowLeft size={14} className="me-1" /> Back to Members List
                    </Button>

                    <div className="d-flex gap-2">
                      <Button
                        type="submit"
                        color="primary"
                        disabled={isSubmitting}
                        className="px-4 fw-bold shadow-sm d-flex align-items-center"
                      >
                        {isSubmitting ? (
                          <>
                            <Spinner size="sm" className="me-2" /> Saving...
                          </>
                        ) : (
                          <>
                            <Save size={16} className="me-2" />
                            {state.id > 0 ? "Save Member Changes" : "Create Member Profile"}
                          </>
                        )}
                      </Button>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </CardBody>
      </Card>

      {/* ─── Full Image Preview Modal ───────────────────────────────────────── */}
      <Modal
        isOpen={imageModal.show}
        toggle={() => setImageModal({ show: false, src: "", title: "" })}
        size="lg"
        centered
      >
        <ModalHeader
          toggle={() => setImageModal({ show: false, src: "", title: "" })}
          className="bg-light py-2"
        >
          <span className="fw-bold">{imageModal.title || "Document Preview"}</span>
        </ModalHeader>
        <ModalBody className="p-2 text-center bg-dark">
          {imageModal.src && (
            <img
              src={imageModal.src}
              alt="Full Preview"
              style={{ maxWidth: "100%", maxHeight: "80vh", objectFit: "contain" }}
            />
          )}
        </ModalBody>
        <ModalFooter className="py-2 d-flex justify-content-between">
          <Button
            color="primary"
            size="sm"
            onClick={() => window.open(imageModal.src, "_blank")}
          >
            Open in New Window
          </Button>
          <Button
            color="secondary"
            size="sm"
            onClick={() => setImageModal({ show: false, src: "", title: "" })}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default AddEdit_MemberMaster;